import React from 'react';
import './ErrorDisplay.css';

/**
 * ErrorDisplay Component - Displays error messages with optional retry/back buttons
 *
 * @param {Object} props
 * @param {string} [props.title="Error Loading Data"] - Error title
 * @param {string} props.message - Error message to display
 * @param {Function} [props.onRetry] - Callback for retry action
 * @param {boolean} [props.showBackButton=false] - Whether to show back button
 * @param {Function} [props.onBack] - Callback for back button
 * @param {string} [props.className=""] - Additional CSS classes
 */
function ErrorDisplay({
  title = "Error Loading Data",
  message,
  onRetry,
  showBackButton = false,
  onBack,
  className = ""
}) {
  return (
    <div className={`error-container ${className}`}>
      <div className="error-icon">⚠️</div>
      <h2>{title}</h2>
      <p>{message}</p>
      <div className="error-actions">
        {onRetry && (
          <button onClick={onRetry} className="retry-button">
            Retry
          </button>
        )}
        {showBackButton && (
          <button onClick={onBack} className="back-button">
            Go Back
          </button>
        )}
      </div>
    </div>
  );
}

export default ErrorDisplay;
